<template>
  <landing-page
    :chamber="config.key"
    :chamberTitle="config.name"
    :loading="loading"
    :models="models"
    :currentModel="model"
    :landingModels="landingModels"
    :lastModelUpdate="lastModelUpdate"
    :meanSeat="meanSeat">
    <span slot="page-title">2022 {{ config.name }} Elections Model</span>
  </landing-page>
</template>

<script>
import LandingMixin from '@/mixins/landingPage'
import { mapGetters } from 'vuex'

const name = 'senate_landing'

const computed = {
  ...mapGetters({
    meanSeat: 'aggregateModels/senateMeanSeat',
  }),
};

const mixins = [
  LandingMixin
]

const props = {
  config: {
    type: Object,
    default: () => {
      return {
        key: 'senate',
        name: 'Senate',
        param: 'SENATE'
      }
    }
  }
}

export default {
  name,
  mixins,
  props,
  computed,
  metaInfo: {
    title: 'Senate',
    meta: [
      {
        vmid: 'og:title',
        name: 'og:title',
        content: 'Senate'
      }, {
        vmid: 'twitter:title',
        name: 'twitter:title',
        content: 'Senate'
      }, {
        vmid: 'description',
        name: 'description',
        content: '2022 U.S. election predictions for Senate and House Congressional elections. Includes model-driven predictions for key Senate and House races, polling and district information, and model simulations updated daily.'
      }, {
        vmid: 'og:description',
        name: 'og:description',
        content: '2022 U.S. election predictions for Senate and House Congressional elections. Includes model-driven predictions for key Senate and House races, polling and district information, and model simulations updated daily.'
      }, {
        vmid: 'twitter:description',
        name: 'twitter:description',
        content: '2022 U.S. election predictions for Senate and House Congressional elections. Includes model-driven predictions for key Senate and House races, polling and district information, and model simulations updated daily.'
      }
    ]
  }
}
</script>
